import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  batchId: string;
  isUnarchive: boolean;
}

export const useArchiveBatch = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ batchId, isUnarchive = false }: HookProps) => {
      const result = isUnarchive
        ? await apiClient.batchesArchive.unarchiveBatch.mutation({ params: { id: batchId } })
        : await apiClient.batchesArchive.archiveBatch.mutation({ params: { id: batchId } });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['batches'] });
      toast.success('Successfully archived the batch!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error archiving the batch!');
    },
  });
};
